// no-dd-sa:typescript-best-practices/boolean-prop-naming
import { create } from 'zustand';

interface DemoModeState {
  isDemoMode: boolean;
  tourStarted: boolean;
  tourCompleted: boolean;
  // Set when a non-owner enters demo mode because their GitHub App install is
  // pending org-admin approval. Lets the demo banner nudge them to chase it.
  installPending: boolean;
  installPendingOrg: string | null;
  installUrl: string | null;
  setDemoMode: (value: boolean) => void;
  setInstallPending: (pending: boolean, org?: string | null, installUrl?: string | null) => void;
  startTour: () => void;
  completeTour: () => void;
  resetTour: () => void;
}

export const useDemoModeStore = create<DemoModeState>()((set) => ({
  isDemoMode: false,
  tourStarted: false,
  tourCompleted: false,
  installPending: false,
  installPendingOrg: null,
  installUrl: null,

  setDemoMode: (value: boolean) => set({ isDemoMode: value }),

  setInstallPending: (pending: boolean, org: string | null = null, installUrl: string | null = null) =>
    set({ installPending: pending, installPendingOrg: org, installUrl }),

  startTour: () => set({ tourStarted: true }),

  completeTour: () => set({ tourStarted: false, tourCompleted: true }),

  resetTour: () => set({ tourStarted: false, tourCompleted: false }),
}));